if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
} 

(function(){

    //header scroll
	let scrollpos = window.scrollY;
	const full_header = document.querySelector('.header');
	const open_table_widget = document.querySelector('.opentable');

    window.addEventListener('scroll', function() { 
        scrollpos = window.scrollY;

		if (scrollpos >= 80) { 
			full_header.classList.remove("up"),
			full_header.classList.add("down"),
			open_table_widget.classList.remove("up"),
			open_table_widget.classList.add("down")
		}
		else { 
			full_header.classList.remove("down"),
			full_header.classList.add("up"),
			open_table_widget.classList.remove("down"),
			open_table_widget.classList.add("up")
		}
		//console.log(scrollpos)
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //tabs sections
	const tabLinks = document.querySelectorAll('.js-tabs-menu a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			for(let k=0; k < tabLinks.length; k++) {
				tabLinks[k].classList.remove('active');
			}
			this.classList.add('active');
			return false;
		}
	}

    //button hover states
	const all_btns = document.querySelectorAll('.btn');
	for (let i = 0; i < all_btns.length; i++) {
		let btn_copy = all_btns[i].textContent;
		all_btns[i].innerHTML = '<span>'+btn_copy+'</span>';  
	}

	const intro_content = document.querySelector('.top-content-home__headline');
    const intro_copy = document.querySelector('.top-content__headline');

	if(intro_content){
		document.getElementsByClassName('top-content-home__headline')[0].classList.add('appear');
	}

    if(intro_copy){
		document.getElementsByClassName('top-content__headline')[0].classList.add('appear');
	}

	const animateHTML = function () {
        let elems,
            elemsShow,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            elemsShow = document.getElementsByClassName('show-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        }; 
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            } 
            for (let i = 0; i < elemsShow.length; i++) {
                let posFromTop = elemsShow[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight >= 0) {
                    elemsShow[i].className = elemsShow[i].className.replace('show-object', 'hide-object')
                } 
            } 
        };
        return {
            init: init 
        }
    };
    animateHTML().init();

    $('.sym-slides').slick({
        accessibility: false
    }); 

    $('.slide-toggle-trigger').click(function(){
        //$('.slide-toggle-content').slideUp();
        $(this).toggleClass('active');
        $(this).next('.slide-toggle-content').slideToggle();
    }); 

})();